export default __webpack_public_path__ + "static/media/ninjatag_GRAJ_BLYSK.1510db60.gif";